export const AUTHLINK_SET = 'AUTHLINK_SET';
export const AUTHLINK_PUSH = 'AUTHLINK_PUSH';
export const AUTHLINK_SUCCESS = 'AUTHLINK_SUCCESS';
export const AUTHLINK_FAIL = 'AUTHLINK_FAIL';

export const APPID_SET = 'APPID_SET';
export const APPID_PUSH = 'APPID_PUSH';

export const LOGOUT = 'LOGOUT';



// WEBPACK FOOTER //
// ./src/constants/Auth.js